export default "__VITE_ASSET__DF9eo95L__"